import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AUTH } from 'src/app/common/firebase/firebase.tokens';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AUTH);

  if (!shouldAttachAuthHeader(req.url)) {
    return next(req);
  }

  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const user = auth.currentUser;

  if (!user) {
    return next(req);
  }

  return from(user.getIdToken()).pipe(
    switchMap(token =>
      next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      )
    )
  );
};

function shouldAttachAuthHeader(url: string): boolean {
  if (!url.includes('/api/') && !url.includes('/v1/')) {
    return false;
  }

  const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:/i.test(url);
  if (!isAbsoluteUrl) {
    return true;
  }

  try {
    return new URL(url).origin === new URL(environment.api.endpoint).origin;
  } catch {
    return false;
  }
}
